export const TRUSTED_CHROME_EXTENSION_IDS = {
  local: 'ceofpnbcmdjbibjjdniemjemmgaibeih',
  dev: 'afhngfaoadjjlhbgopehflaabbgfbcmn',
  beta: 'foilfbjokdonehdajefeadkclfpmhdga',
  prod: 'nnpmfplkfogfpmcngplhnbdnnilmcdcg',
}
